import { takeEvery } from 'redux-saga/effects';

import actionTypes from '../../actionTypes';

import {
	deleteSavedHierarchy,
	editSavedHierarchy,
	getBusinessHierarchy,
	getSavedHierarchy,
	saveHierarchy,
	updateSavedHierarchy,
	validateHierarchy,
	getUserAuth
} from './fullCompanyViewSaga';

export default function* fullCompanyViewWatcher() {
	yield takeEvery(actionTypes.GET_BUSINESS_HIERARCHY, getBusinessHierarchy);
	yield takeEvery(actionTypes.GET_SAVED_HIERARCHY, getSavedHierarchy);
	yield takeEvery(actionTypes.SAVE_HIERARCHY, saveHierarchy);
	yield takeEvery(actionTypes.DELETE_SAVED_HIERARCHY, deleteSavedHierarchy)
	yield takeEvery(actionTypes.EDIT_SAVED_HIERARCHY, editSavedHierarchy)
	yield takeEvery(actionTypes.VALIDATE_HIERARCHY, validateHierarchy)
	yield takeEvery(actionTypes.UPDATE_SAVED_HIERARCHY, updateSavedHierarchy)
	yield takeEvery(actionTypes.GET_USER_AUTH, getUserAuth)
}
